export const normalize = post => {
  const normalizedData = { ...post };


  return normalizedData;
};
